import { render } from "./EscalationTable.vue?vue&type=template&id=c515da78"
import script from "./EscalationTable.vue?vue&type=script&lang=js"
export * from "./EscalationTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__